<template>
  <el-dialog
    :title="title"
    :visible="dialogFormVisible"
    :before-close="handleClose"
    class="dialog-form"
    width="60%"
  >
    <table-form
      :dataSource="dataSource"
      ref="form"
      :tableData="formData"
      :disable="disabled"
    ></table-form>
    <div class="upload">
      <el-table :data="dataUp" style="width: 100%" border>
        <el-table-column
          type="index"
          label="序号"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="title"
          label="材料名称"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="oldFile"
          label="附件名称"
          width="auto"
        ></el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <a href="javascript:void(0);" class="input">
              上传
              <input
                :key="dialogFormVisible"
                type="file"
                class="file"
                @change="getFile($event, scope)"
                accept="application/pdf,image/*,application/x-zip-compressed,application/x-rar-compressed"
              />
            </a>
          </template>
        </el-table-column>
        <el-table-column label="下载附件" width="100">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              :disabled="scope.row.newFile ? false : true"
              @click="downFile(scope.row)"
              style="font-size:14px"
              >下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" class="pull-left" @click="allDisabled"
        >编辑</el-button
      >
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submit()">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import TableForm from "common/components/form/tableForm1";
import { step3 } from "@/conf/newAgency";
import {
  singleUpload,
  addPersonInfo,
  updateFinanceLinkman,
  selectDic,
  institutionDownLoadCommon,
} from "common/js/api";

export default {
  components: {
    TableForm,
  },

  props: ["dialogVisible", "title", "tableData", "detailId", "codeId", "type"], //falg判断是联系人、负责人

  data() {
    return {
      dataSource: [],
      dialogFormVisible: false,
      formData: {},
      disabled: true,
      dataUp: [
        {
          title: "身份证",
          oldFile: "--",
          newFile: "",
        },
        {
          title: "学位/学历材料",
          oldFile: "--",
          newFile: "",
        },
        {
          title: "基金从业资格证",
          oldFile: "--",
          newFile: "",
        },
        {
          title: "简历",
          oldFile: "--",
          newFile: "",
        },
      ],
      upIndex: 0,
      isAgency: false,
    };
  },

  mounted() {
    // const step = step3[1].concat(step3[1]);
    this.dataSource = this.$lodash.cloneDeep(step3[1]);
    this.dataSource = this.dataSource.slice(0, 13);
    this.isAgency =
      this.$route.path == "/FundManagement/NewAgency" ? false : true;
    if (!this.isAgency) {
      this.getSelect();
    }
    console.log(this.dataSource);

    if (this.isAgency) {
      this.dataSource = this.$lodash.cloneDeep(step3[3]);
      this.dataUp.splice(1, 2);
      console.log("this.dataSource");
      console.log(this.dataSource);
      //this.dataSource[1].personType=2;
    }
  },

  methods: {
    allDisabled() {
      console.log(this.disabled);
      this.disabled = false;
      if (this.disabled == false) {
        this.$message({
          message: "已开启编辑模式",
          type: "success",
        });
      }
    },
    async downFile(row) {
      // const fileData = row.newFile.split("/");
      // const suffix = fileData[3].split(".");
      // await downLoadCommon(fileData[0], suffix[1], row.oldFile, suffix[0]);
      const filePath = row.newFile;
      const fileName = row.oldFile;
      console.log("@@row", row);
      console.log("@@filePath", filePath);
      console.log("@@fileName", fileName);
      const params = {
        filePath: filePath,
        fileName: fileName,
      };
      await institutionDownLoadCommon(params);
    },

    async getSelect() {
      const query = "7,8";
      const result = await selectDic(query);
      const { CHINESE_NATION, EDUCATION_BACKGROUND } = result.result;
      // this.converSelect(CHINESE_NATION, 2);//民族
      this.converSelect(EDUCATION_BACKGROUND, 4);
    },

    converSelect(option, index) {
      option.forEach((item) => {
        let data = {
          label: item,
          value: item,
        };
        this.dataSource[index].options.push(data);
      });
    },

    handleClose() {
      this.dialogFormVisible = false;
      this.resetForm();
      this.$emit("closeDialog");
    },

    handlerSubmitClose() {
      this.dialogFormVisible = false;
      this.resetForm();
      this.$emit("reload");
    },

    getFile(event, scope) {
      this.upIndex = scope.$index;
      let file = event.target.files[0];
      let fileName = file.name;
      if (file) {
        let idx = fileName.lastIndexOf(".");
        if (idx != -1) {
          let ext = fileName.substr(idx + 1).toUpperCase();
          ext = ext.toLowerCase();
          if (
            // ext != "bmp" &&
            // ext != "jpg" &&
            // ext != "png" &&
            // ext != "jpeg" &&
            // ext != "gif" &&
            // ext != "webp" &&
            // ext != "svg" &&
            // ext != "tiff" &&
            // ext != "pjp" &&
            // ext != "jfif" &&
            // ext != "xbm" &&
            // ext != "dib" &&
            // ext != "jxl" &&
            // ext != "svgz" &&
            // ext != "tif" &&
            // ext != "pjpeg" &&
            // ext != "avif" &&
            ext != "pdf" &&
            ext != "rar" &&
            ext != "zip"
          ) {
            this.$message.error(
              "请上传格式正确的文件，支持pdf、rar和zip"
            );
          } else {
            this.file = file;
            this.oldFile = fileName;
            this.$message({
              type: "warning",
              message: "文件开始上传",
            });
            this.uploadForm(event);
          }
        }
      }
    },

    async uploadForm(event) {
      event.preventDefault();
      let formData = new FormData();
      formData.append("file", this.file);
      formData.append("ftCode", this.Cookies.get("selectedBasicFtCode"));
      formData.append("institutionName", this.Cookies.get("institutionName"));
      let loadingInstance = this.$loading({ fullscreen: true });
      let a = setTimeout(() => {
        loadingInstance.close();
      }, 120000);
      const result = await singleUpload(formData);
      clearTimeout(a);
      loadingInstance.close();

      console.log("###", result);
      console.log("###", this.dataUp);
      this.dataUp[this.upIndex].oldFile = result.result.orignName;
      this.dataUp[this.upIndex].newFile = result.result.storePath;

      this.$message({
        message: "上传成功",
        type: "success",
      });
    },

    async submit() {
      const isValidate = this.$refs.form.submitForm();
      if (!isValidate) return false;
      let form = this.$refs.form.form;
      if (
        !this.isAgency &&
        form.personName == "" &&
        form.personType == "" &&
        form.certificateNo == "" &&
        form.contactTel == "" &&
        form.supreEducationProid == "" &&
        form.qualification == ""
      ) {
        this.$message({
          message: "请将必填项填写完整",
          type: "warning",
        });
      } else if (
        this.isAgency &&
        form.personName == "" &&
        form.certificateNo == "" &&
        form.email == "" &&
        form.contactTel == ""
      ) {
        this.$message({
          message: "请将必填项填写完整",
          type: "warning",
        });
      } else {
        form.type = this.type;
        form["institutionCode"] = this.codeId;
        if (this.isAgency) {
          // 身份证
          form.identifyCardOrignName = this.dataUp[0].oldFile;
          form.identifyCardStorePath = this.dataUp[0].newFile;
          // 简历;
          form.abstractInfoOrignName = this.dataUp[1].oldFile;
          form.abstractInfoStorePath = this.dataUp[1].newFile;
          //直接赋值为企业法人。
          form.personType = "2";
        } else {
          // 简历;
          form.abstractInfoOrignName = this.dataUp[3].oldFile;
          form.abstractInfoStorePath = this.dataUp[3].newFile;
          // 最高学历
          form.degreeFileOrignName = this.dataUp[1].oldFile;
          form.degreeFileStorePath = this.dataUp[1].newFile;
          // 身份证
          form.identifyCardOrignName = this.dataUp[0].oldFile;
          form.identifyCardStorePath = this.dataUp[0].newFile;
          // 基金从业资格证
          form.qualificationOrignName = this.dataUp[2].oldFile;
          form.qualificationStorePath = this.dataUp[2].newFile;
        }
        console.log("@persons@form", form);
        // code id
        form.institutionCode = this.codeId;
        if (this.title.includes("编辑")) {
          form.id = this.tableData.id;
        } else {
          form.id = 0;
        }
        console.log("form.qualification is", typeof form.qualification);
        //添加人员信息
        if (this.title.includes("添加")) {
          await addPersonInfo(form);
        } else {
          //更新人员信息
          await updateFinanceLinkman(form);
        }
        const message = this.title.includes("添加") ? "添加" : "编辑";
        this.$message({
          message: `${this.title}成功!`,
          type: "success",
        });
        this.handlerSubmitClose();
      }
    },

    resetForm() {
      this.formData = {};
      this.dataUp.forEach((item) => {
        item.oldFile = "";
        item.newFile = "";
      });
    },

    editSetDetail(tableData) {
      console.log("this--editSetDetail>", tableData);
      if (this.isAgency) {
        if (tableData.identifyCardStorePath) {
          this.dataUp[0].oldFile = tableData.identifyCardOrignName;
          this.dataUp[0].newFile = tableData.identifyCardStorePath;
        }
        if (tableData.abstractInfoStorePath) {
          this.dataUp[1].oldFile = tableData.abstractInfoOrignName;
          this.dataUp[1].newFile = tableData.abstractInfoStorePath;
        }
      } else {
        if (tableData.identifyCardStorePath) {
          this.dataUp[0].oldFile = tableData.identifyCardOrignName;
          this.dataUp[0].newFile = tableData.identifyCardStorePath;
        }
        if (tableData.degreeFileStorePath) {
          this.dataUp[1].oldFile = tableData.degreeFileOrignName;
          this.dataUp[1].newFile = tableData.degreeFileStorePath;
        }
        if (tableData.qualificationStorePath) {
          this.dataUp[2].oldFile = tableData.qualificationOrignName;
          this.dataUp[2].newFile = tableData.qualificationStorePath;
        }
        if (tableData.abstractInfoStorePath) {
          this.dataUp[3].oldFile = tableData.abstractInfoOrignName;
          this.dataUp[3].newFile = tableData.abstractInfoStorePath;
        }
      }
    },
  },

  watch: {
    dialogVisible(newValue) {
      this.dialogFormVisible = newValue;
      if (newValue && this.title.includes("编辑")) {
        this.editSetDetail(this.tableData);
        this.disabled = true;
      }
      if (this.title.includes("添加")) {
        this.disabled = false;
      }
    },
    tableData: {
      handler(newValue) {
        this.formData = newValue;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.upload {
  padding-top: 30px;
}

/*input*/
.file_name {
  width: 50%;
  text-indent: 10px;
  border: 1px solid #ccc;
  height: 30px;
}

a.input {
  width: 70px;
  /* border-radius: 5px; */
  height: 30px;
  margin-top: 1px;
  vertical-align: top;
  line-height: 28px;
  /* background: #409EFF; */
  /* background: #3091d1; */
  text-align: center;
  display: inline-block;
  overflow: hidden;
  position: relative;
  vertical-align: bottom;
  text-align: left;
}

/* a.input:hover {
  background: #66b1ff;
  color: #ffffff;
} */

a {
  text-decoration: none;
  color: #3165ff;
  position: absolute !important;
  left: 10px;
  top: 10px;
  font-size: 13px;
}

.file {
  opacity: 0;
  /*设置此控件透明度为零，即完全透明*/
  filter: alpha(opacity=0);
  /*设置此控件透明度为零，即完全透明针对IE*/
  font-size: 100px;
  cursor: pointer;
  position: absolute;
  /*绝对定位，相对于 .input */
  top: 0;
  right: 0;
}
</style>
